import Request from "@wwdev/bootstrap/Request";

class Samples {
	Request;

	timeout = null;

	constructor(config) {
		this.config = Object.assign({
			scope: '[data-samples="scope"]',
			wrapper: '[data-samples="wrapper"]',
			amount: '[data-samples="amount"]',
			plus: '[data-samples="plus"]',
			minus: '[data-samples="minus"]',
			deleteButton: '[data-samples="delete"]',
			offcanvasFooter: '.offcanvas-footer'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.config.errormessage = this.$scope[0].dataset.errorMessage;

		this.initRequest();
		$(document).off('.samplerequest')
			.on('click.samplerequest', `${this.config.scope} ${this.config.plus}`, this.onPlus.bind(this))
			.on('click.samplerequest', `${this.config.scope} ${this.config.minus}`, this.onMinus.bind(this))
			.on('click.samplerequest', `${this.config.scope} ${this.config.deleteButton}`, this.onDelete.bind(this))
			.on('change.samplerequest', `${this.config.scope} ${this.config.amount}`, this.onInputChange.bind(this));
	}

	initRequest() {
		this.Request = new Request();
		this.Request.request['action'] = 'amount';
		this.Request.doRequest = this._doRequest.bind(this);
		this.Request.handleResponse = this._handleResponse.bind(this);
		this.Request.setProductAmount = this._setProductAmount.bind(this);

		this.$scope.first().find(this.config.amount).each((index, element) => {
			let $element = $(element);
			let amount = $element.val();
			let product = $element.closest('[data-product]').data('product');
			this.Request.setProductAmount(product, amount);
		});
	}

	onAmountChange(event) {
		let $input = $(event.currentTarget);
		let product = $input.closest('[data-product]').data('product');
		this.Request.setProductAmount(product, $input.val());
		this._reload();
	}

	getTotalAmount(event) {
		let totalAmount = 0;
		let $button = $(event.currentTarget);
		let $wrapper = $button.closest(this.config.wrapper);
		return $wrapper.find(this.config.scope).length;
	}

	onPlus(event) {
		let $button = $(event.currentTarget);
		let $parent = $button.closest('[data-product]')
		let $input = $parent.find('input');
		let product = $parent.data('product');
		let amount = parseInt($input.val());

		if(amount < 3) {
			$input.val(amount + 1);
			$input.trigger('change');
		}
	}

	onMinus(event) {
		let $scope = $(event.currentTarget).closest(this.config.scope);
		let product = $scope.data('product');
		let $input = $scope.find(this.config.amount);
		var amount = Math.max(parseInt($input.val()) - 1, 1);
		$input.val(amount);
		$input.trigger('change');
	}

	onInputChange(event) {
		let $input = $(event.currentTarget);
		let $scope = $input.closest(this.config.scope);
		let product = $scope.data('product');
		var amount = parseInt($input.val());

		this.Request.setProductAmount(product, amount);
		this._reload();
	}

	onDelete(event) {
		event.preventDefault();

		let $button = $(event.currentTarget);
		if(confirm($button.data('confirm'))) {
			let product = $button.closest('[data-product]').data('product');

			$.ajax({
				url: this._getBaseUrl(),
				method: 'POST',
				data: {
					product: product,
					action: 'delete'
				},
				success: this._handleResponse.bind(this),
				error: (response) => alert('er is iets fout gegaan')
			});
		}
	}

	_reload() {
		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => {
			this.Request.doRequest();
		}, 400);
	}

	_handleResponse(response) {
		this.$scope.find(this.config.wrapper).html(response.html);
		this.refreshIndicator(response);
		this.showSuccessMessage(response);
	}

	refreshIndicator(response) {
		$('[data-scope="staalAmount"]').each(function() {
			$(this).html(response.amount);
		});
	}

	showSuccessMessage(response) {
		if (response.message) {
			let $toast = $('[data-scope="toast"]');
			let $content = $toast.find('[data-scope="content"]');
			$content.html(response.message);
			let toastEl = $toast.get(0);
			new bootstrap.Toast(toastEl).show();

			toastEl.addEventListener('hidden.bs.toast', () => {
				$content.html('');
			});
		}
	}

	_setProductAmount(product, amount) {
		if (!this.Request.request.hasOwnProperty('amounts')) {
			this.Request.request.amounts = {};
		}
		this.Request.request.amounts[product] = amount;
	}

	async _doRequest() {
		await $.ajax({
			url: this._getBaseUrl(),
			method: 'POST',
			data: this.Request.request,
			success: this.Request.handleResponse,
			error: (response) => {
				let message = response.responseJSON.message;
				if(message) {
					$.ajax({
						url: window.location.pathname + '?error=' + message,
						method: 'get',
						success: (response) => {
							let content = $(response).find('[data-samples="scope"]').html();
							$(document).find('[data-samples="scope"]').html(content);
							setTimeout(() =>{
								$('[data-error-alert]').slideUp();
							}, 6000)
						}
					})
				} else {
					alert('er is iets fout gegaan');
				}
			},
		});

		return false;
	}

	_getBaseUrl() {
		return $('input[name="samplerequest_url"]').attr('value');
	}
}

export default new Samples;
